export default {
  navBarOpen: false,
  isGrid: true,
  collectionsViewState: "grid",
  currentMap: { langCode: "en", level: 0 },
  visitorAlert: true,
  audioDetails: {
    url: null,
    isPlaying: false,
    title: null,
    subtitle: null,
  },
  parentRouteDetails: {
    path: null,
    title: null, // if this === 'back', it will use browser's backwards navigation
  },
  collectionsSearchTerm: "",
  forFamiliesExperienceIsGrid: true,
  // since intitial state for exploredArt relies on
  // localStorage, and localStorage isn't available in
  // gatsby build, setting in Layout.js
  exploredArt: null,
  scavengerHuntEsp: {
    firstFloor: [
      {
        id: 0,
        text: "encuentra al artista (usa sombrero)",
        checked: false, 
      },
      {
        id: 1,
        text: "obra de arte con un conejo",
        checked: false, 
      },
      {
        id: 2,
        text: "obra de arte con un trineo",
        checked: false, 
      },
      {
        id: 3,
        text: "obra de arte con estampa",
        checked: false, 
      },
      {
        id: 4,
        text: "obra de arte con una rosa",
        checked: false, 
      },
      {
        id: 5,
        text: "obra de arte con un limón",
        checked: false, 
      },
      {
        id: 6,
        text: "obra de arte con abejas, colmena o miel",
        checked: false, 
      },
      {
        id: 7,
        text: "fotografías",
        checked: false, 
      },
      {
        id: 8,
        text: "objeto que podrías encontrar en una cocina",
        checked: false, 
      },
      {
        id: 9,
        text: "objeto que podrias llevar puesto",
        checked: false, 
      },
      {
        id: 10,
        text: "objeto que reproduce música",
        checked: false, 
      },
      {
        id: 11,
        text: "obra de arte que tú harías",
        checked: false, 
      },
    ],
    thirdFloor: [
      {
        id: 12,
        text: "obra de arte con los tres colores primarios (rojo, amarillo, azul)",
        checked: false,
      },
      {
        id: 13,
        text: "obra de arte con tu color favorito",
        checked: false,
      },
      {
        id: 14,
        text: "obra de arte en blanco y negro",
        checked: false,
      },
      {
        id: 15,
        text: "obra de arte que incluye personas",
        checked: false,
      },
      {
        id: 16,
        text: "obra de arte que incluye un animal",
        checked: false,
      },
      {
        id: 17,
        text: "escultura",
        checked: false,
      },
      {
        id: 18,
        text: "obra de arte que te hace reír",
        checked: false,
      },
      {
        id: 19,
        text: "obra de arte que te hace sentir triste",
        checked: false,
      },
      {
        id: 20,
        text: "obra de arte de otro país",
        checked: false,
      },
      {
        id: 21,
        text: "obra de hecha de metal",
        checked: false,
      },
      {
        id: 22,
        text: "obra de arte hecha de madera",
        checked: false,
      },
      {
        id: 23,
        text: "pintura abstracta",
        checked: false,
      },
    ],
  },
  scavengerHuntEng: {
    firstFloor: [
      {
        id: 0,
        text: "find the artist (he is wearing a hat)",
        checked: false, 
      },
      {
        id: 1,
        text: "artwork with a rabbit",
        checked: false, 
      },
      {
        id: 2,
        text: "artwork with a sled",
        checked: false, 
      },
      {
        id: 3,
        text: "artwork with stamps",
        checked: false, 
      },
      {
        id: 4,
        text: "artwork with a rose",
        checked: false, 
      },
      {
        id: 5,
        text: "artwork with a lemon",
        checked: false, 
      },
      {
        id: 6,
        text: "artwork including bees, beehive or honey",
        checked: false, 
      },
      {
        id: 7,
        text: "photograph",
        checked: false, 
      },
      {
        id: 8,
        text: "object from the kitchen",
        checked: false, 
      },
      {
        id: 9,
        text: "something you could wear",
        checked: false, 
      },
      {
        id: 10,
        text: "something that plays music",
        checked: false, 
      },
      {
        id: 11,
        text: "artwork that you would make",
        checked: false, 
      },
    ],
    thirdFloor: [
      {
        id: 12,
        text: "artwork with all three primary colors (red, yellow, blue)",
        checked: false,
      },
      {
        id: 13,
        text: "artwork with your favorite color",
        checked: false,
      },
      {
        id: 14,
        text: "artwork that is black and white",
        checked: false,
      },
      {
        id: 15,
        text: "artwork that includes people",
        checked: false,
      },
      {
        id: 16,
        text: "artwork that includes an animal",
        checked: false,
      },
      {
        id: 17,
        text: "sculpture",
        checked: false,
      },
      {
        id: 18,
        text: "artwork that makes you laugh",
        checked: false,
      },
      {
        id: 19,
        text: "artwork that makes you sad",
        checked: false,
      },
      {
        id: 20,
        text: "artwork from another country",
        checked: false,
      },
      {
        id: 21,
        text: "artwork made of metal",
        checked: false,
      },
      {
        id: 22,
        text: "artwork made of wood",
        checked: false,
      },
      {
        id: 23,
        text: "abstract painting",
        checked: false,
      },
    ],
  },
};
